import React from 'react';
import PropTypes from 'prop-types';

const VideoModal = props => (
  <div>
    <h4 style={{ textAlign: 'center', paddingBottom: '5px' }}>{props.src.document_name}</h4>
    <video width="390" height="844" autoPlay>
      <source src={props.src.expiring_download_url} type="video/mp4" />
    </video>
  </div>
  );

VideoModal.propTypes = {
  src: PropTypes.object.isRequired,
};

export default VideoModal;



// WEBPACK FOOTER //
// ./client/app/shared/components/DocumentsTable/Images/videoModal.jsx